import React, { useEffect, useState } from "react";
import { Box, Typography, Breadcrumbs, Tabs, Tab } from "@mui/material";
import MaterialButton from "@mui/material/Button";

import { useKeycloak } from "@react-keycloak/web";

import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../../components/super-admin/common/Loader";
import OrgInfoCard from "../../../components/super-admin/org/orgInfo/OrgInfoCard";
import OrgUserTable from "../../../components/super-admin/org/orgUserInfoTab/OrgUserTable";
import { useOrgDetailsSA, useOrgUsers } from "../../../tanstackQuery/queries/superAdmin/org";
import InviteUserTable from "../../../components/super-admin/org/InviteUserTab/InviteUserTable";
import InviteManagementTable from "../../../components/super-admin/org/InviteManagementTab/InviteManagementTable";
import InvoiceAndLicenseInfoTable from "../../../components/super-admin/org/InvoiceAndLicenseInfoTab/InvoiceAndLicenseInfoTable";
import { SAdminBaseAtom } from "../../../stores/jotai/super-admin/superAdminBase";
import { useAtom } from "jotai";
import { usePaywallProductsSA } from "../../../tanstackQuery/queries/superAdmin/product";
import { useGetInvoices } from "../../../tanstackQuery/queries/superAdmin/invoice";
import PendingUserListTable from "../../../components/super-admin/org/PendingUserTab/PendingUserListTable";
import { usePendingUserList } from "../../../tanstackQuery/queries/superAdmin/invite";
import { useQueryClient } from "@tanstack/react-query";
import { useGetOrgTreeData } from "../../../tanstackQuery/queries/org-tree";

const ManageOrg = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { keycloak } = useKeycloak();
  const { orgID } = useParams();
  const navigate = useNavigate();
  const [sAdminBase, setSAdminBase]=useAtom(SAdminBaseAtom);

  const { data: orgTreeData, isLoading: isOrgTreeLoading } = useGetOrgTreeData(
        { accessToken: keycloak?.token },
        { orgID },
        {
            enabled: !!orgID,
        }
  );
  const orgName = sAdminBase?.selectedOrg?.name;

  const { data: orgUsersData, isLoading: isOrgUserLoading } = useOrgUsers(
    { accessToken: keycloak?.token },
    { orgID },
    { enabled: !!keycloak?.token && !!orgID }
  );

  const { data: orgDetails, isLoading: isOrgDetailsLoading } = useOrgDetailsSA(
      { accessToken: keycloak?.token },
      { orgID },
      { enabled: !!keycloak?.token && !!orgID }
  );
  const { data: productDetails, isLoading: isProductDetailsLoading } = usePaywallProductsSA(
      { accessToken: keycloak?.token },
      { enabled: !!keycloak?.token }
  );
  const { data: pendingUserList, isLoading: isPendingUserListLoading } = usePendingUserList(
      { accessToken: keycloak?.token },
      { orgID },
      { enabled: !!keycloak?.token }
  );
  const userData = orgUsersData || [];

  const handleTabChange = (event, newIndex) => {
    setActiveTab(newIndex);
  };

  const { data: invoicesData, isLoading: isInvoicesLoading } = useGetInvoices(
    { accessToken: keycloak?.token },
    { orgID },
    { 
      enabled: !!(keycloak?.token && orgID),
      retry: 1, 
      retryDelay: 3000, 
    }
  );
  
  useEffect(() => {
    if (!orgTreeData || !orgID) return;

    const matchedOrg = orgTreeData.orgs?.find((orgItem) => orgItem?.orgID === orgID);

    if (matchedOrg) {
      setSAdminBase((prev) => ({
        ...prev,
        selectedOrg: matchedOrg,
      }));
    }
  }, [orgTreeData, orgID, setSAdminBase]);


  if (isOrgUserLoading || isOrgDetailsLoading || isProductDetailsLoading || isInvoicesLoading || isPendingUserListLoading || isOrgTreeLoading) {
    return <Loader />;
  }

  return (
    <>
      <Typography variant="h5" sx={{ fontWeight: "bold", paddingLeft: "6px" }}>
        Organization Details: {orgDetails?.name || null}
      </Typography>
      <Box style={{ paddingLeft: 6 }}>
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{ backgroundColor: "#f4f4f4" }}
        >
          <Typography color="inherit">{orgName}</Typography>
        </Breadcrumbs>
        <Box style={{ paddingTop: 10 }}>
          <MaterialButton variant="contained" onClick={() => navigate(-1)}>
            Return
          </MaterialButton>
        </Box>
      </Box>

      <OrgInfoCard 
         orgDetails={orgDetails} 
         orgUserData={userData} 
         productDetails={productDetails} 
         pendingUserList={pendingUserList}
         invoicesData={invoicesData}
      />

      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        sx={{ mb: 2, display: "flex", gap: 5 }}
      >
        <Tab value={0} label="User List" />
        <Tab value={2} label="Invoice & License" sx={{ minWidth: 150 }} />
        <Tab value={1} label="Manage Invite Session" sx={{ minWidth: 190 }} />
        {/* <Tab value={2} label="Invite User" sx={{ minWidth: 100 }} /> */}
        <Tab value={3} label="Pending User List" sx={{ minWidth: 150 }} />
      </Tabs>
      {activeTab === 0 && <OrgUserTable orgUserData={userData} orgID={orgID}/>}
      {activeTab === 1 && <InviteManagementTable />}
      {/* {activeTab === 2 && <InviteUserTable/>} */}
      {activeTab === 2 && <InvoiceAndLicenseInfoTable />}
      {activeTab === 3 && <PendingUserListTable pendingUserList={pendingUserList}/>}
    </>
  );
};

export default ManageOrg;
